<template>
	<div v-if="contact"
	 class="contact-block panel panel-default sidebar-menu wow fadeInLeft animated" 
		style="visibility: visible; margin-bottom: 5px">
		<div class="panel-heading">
			<h3 class="panel-title">{{ $t("contact.title") }}</h3>
		</div>
		<div class="panel-body text-widget">
			<p>
				{{ $t('configurator.descriptions.contact_general') }}<br />
				{{ $t('configurator.descriptions.contact_order') }}
			</p>
			<div v-show="contact.image"
				class="img-contact-image">
				<img :src="contact.image" class="img-responsive img-contact" alt="contact image">
			</div>
			<b>{{ contact.name }}</b>
			<ul class="list-unstyled">
				<li v-show="contact.phone">
					<i class="fa fa-phone" aria-hidden="true"></i> {{ contact.phone }}
				</li>
				<li v-show="contact.email">
					<i class="fa fa-envelope" aria-hidden="true"></i> {{ contact.email }}
				</li>
				<li v-show="contact.website">
					<i class="fa fa-globe" aria-hidden="true"></i> <a :href="contact.website" :target="'_blank'">{{ contact.website }}</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	contact: {
		default: null,
		required: true
	},
})
</script>
